import { MemberAnketaQuestions } from './MemberAnketaQuestions';

export default MemberAnketaQuestions;